export default __webpack_public_path__ + "static/media/evmotor.f61f585e.jpg";